export default __webpack_public_path__ + "static/media/different-aspects-of-life.eb833370.svg";